import React from "react";
import { Card } from "@/components/ui/card";

const ipotesi = [
  "Trasferte (pernotti, pasti, out-of-pocket) sono attribuite al singolo rapporto del tecnico.",
  "Italia/estero viene determinato dal paese dello stabilimento associato al ticket.",
  "I tariffari Italia/Estero sono dimostrativi: qta × prezzo unitario, senza maggiorazioni festivi/straordinari/soglie giornaliere.",
  "Le fasi 3-7 possono essere marcate 'Non applicabile' con motivazione; le fasi 1 e 2 sono obbligatorie per l'operatività.",
  "Il completamento del rapporto di un tecnico non chiude automaticamente la fase 4: Elisa deve dichiarare conclusa l'attività tecnica.",
  "Il codice E/G (E26-P#### o G26-P####) viene generato quando la classificazione diventa Economia o Garanzia; il precedente resta nello storico come 'annullato'.",
  "La conferma cliente è legata a una specifica versione del consuntivo. Una nuova versione richiede una nuova conferma.",
  "La chiusura del ticket è sempre esplicita e riservata a Elisa o Amministratore demo. Fasi incomplete richiedono una motivazione.",
];

const simulate = [
  { titolo: "Simula richiesta da email", desc: "Precarica una bozza da un messaggio fittizio. Non vengono lette caselle email reali." },
  { titolo: "Firma dimostrativa", desc: "Traccia una firma sullo schermo e viene salvata come SVG. Nessun valore legale." },
  { titolo: "SharePoint / Outlook / Gamma", desc: "Non collegati. L'archivio documenti è interno al ticket. L'emissione fattura resta esterna." },
  { titolo: "Video allegati", desc: "Elemento dimostrativo etichettato. Il caricamento video reale è escluso." },
  { titolo: "Offline reale", desc: "Non implementato. Messaggio: 'Funzionamento offline da validare in una fase successiva'." },
  { titolo: "Accessi simulati", desc: "Il selettore 'Prova come' è un cambio di ruolo di prova, non un sistema di autenticazione." },
];

const limiti = [
  "Nessuna integrazione con Microsoft 365, SharePoint, Outlook, Gamma.",
  "Nessuna autenticazione reale, ruoli e permessi sono lato client per la demo.",
  "Nessuna ottimizzazione dei percorsi tecnico o sincronizzazione calendari.",
  "Nessuna gestione moduli 'Commesse impianto' o 'Ricambi': solo passaggio con reparto e nota.",
];

export default function IpotesiPage() {
  return (
    <div className="p-4 md:p-8 max-w-4xl mx-auto space-y-6">
      <h1 className="text-3xl font-bold">Ipotesi della demo</h1>
      <p className="text-slate-600">Scelte adottate per la parte non esplicitata nel brief, in modo da avere una demo completa e coerente.</p>

      <Card className="emmepi-card p-5">
        <h2 className="font-semibold text-lg mb-3">Regole adottate</h2>
        <ul className="space-y-2 list-disc pl-5 text-slate-700 text-sm">{ipotesi.map((i,idx) => <li key={idx}>{i}</li>)}</ul>
      </Card>

      <Card className="emmepi-card p-5">
        <h2 className="font-semibold text-lg mb-3">Funzioni simulate</h2>
        <div className="space-y-3">
          {simulate.map((s,i) => (
            <div key={i} className="text-sm">
              <span className="font-semibold text-blue-800">{s.titolo}</span>
              <span className="text-slate-600"> — {s.desc}</span>
            </div>
          ))}
        </div>
      </Card>

      <Card className="emmepi-card p-5">
        <h2 className="font-semibold text-lg mb-3">Limiti residui</h2>
        <ul className="space-y-2 list-disc pl-5 text-slate-700 text-sm">{limiti.map((i,idx) => <li key={idx}>{i}</li>)}</ul>
      </Card>
    </div>
  );
}
